<template>
    <input :readonly="true"/>
</template>

<script>

import $ from 'jquery'
import 'jquery-ui/ui/widgets/datepicker'
import 'jquery-ui-timepicker-addon/dist/jquery-ui-timepicker-addon'
import 'jquery-ui-timepicker-addon/dist/jquery-ui-timepicker-addon.css'
import '@/assets/jquery-ui-1.12.1.custom/jquery-ui.css'

export default {
  props: [ 'dateFormat' ],
  data () {
    return {
      buttonPanel: false,
      dataPicker: null
    }
  },
  methods: {
    setDate (date) {
      this.dataPicker.datetimepicker('setDate', date)
    },
    getDate () {
      return this.dataPicker.datetimepicker('getDate')
    }
  },
  mounted: function () {
    if (localStorage.getItem('tz_selected') === 'LocalTZ') {
      this.buttonPanel = true
    }
    var self = this
    this.dataPicker = $(this.$el).datetimepicker({
      showButtonPanel: this.buttonPanel,
      controlType: 'select',
      oneLine: true,
      timeFormat: 'HH:mm:ss',
      monthNames: [ this.$i18n.t('January'),
        this.$i18n.t('February'),
        this.$i18n.t('March'),
        this.$i18n.t('April'),
        this.$i18n.t('May'),
        this.$i18n.t('June'),
        this.$i18n.t('July'),
        this.$i18n.t('August'),
        this.$i18n.t('September'),
        this.$i18n.t('October'),
        this.$i18n.t('November'),
        this.$i18n.t('December')],
      timeText: this.$i18n.t('Time'),
      currentText: this.$i18n.t('Now'),
      closeText: this.$i18n.t('Close'),
      dayNamesMin: [this.$i18n.t('Su'),
        this.$i18n.t('Mo'),
        this.$i18n.t('Tu'),
        this.$i18n.t('We'),
        this.$i18n.t('Th'),
        this.$i18n.t('Fr'),
        this.$i18n.t('Sa')],
      autoSize: true,
      dateFormat: this.dateFormat,
      onSelect: function (date) {
        self.$emit('update-date', date)
      }
    }).prop('placeholder', this.dateFormat)
    this.dataPicker.datetimepicker('setDate', this.$root.getMomentWithTZDelta(new Date() / 1000).toDate())
    this.$emit('dp_mounted', this.dataPicker)
  },
  beforeDestroy: function () {
    $(this.$el).datetimepicker('hide').datetimepicker('destroy')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/datePicker.vue